import I18n from 'lib/i18n/i18n';

export const WORTHY_API_ERRORS = {
    ERR_NETWORK: -1,
    ERR_GENERIC: 0,
    //HTTP error codes are generic
    AUTHORIZATION: 1000,
    EMAIL_TAKEN: 1100,
    INVALID_EMAIL: 1200,
    MISSING_DETAILS: 2000,
    ESTIMATION_FAILED: 3000,
    ESTIMATION_MINIMUM: 3100,
    ESTIMATION_NOT_READY: 3200,
    BUNDLE_NOT_ESTIMATED: 3300,
    WRONG_STATE: 4000,
    WRONG_ADDRESS: 5000
};

export default class WorthyApiErrors {
    constructor(response) {
        const res = response.response;
        try {
            if (!res.data && !res.status) { //network error
                this._data = {};
                this._errObj = {};
                this._errObj[WORTHY_API_ERRORS.ERR_NETWORK] = '';
            }
            else if (res.status >= 400 && res.status <= 599) { //http error
                this._data = response.data || (response.response && response.response.data) || {};
                this._errObj = {};
                this._errObj[res.status] = res.statusText;
            } else { //API error
                this._data = res.data;
                this._errObj = res.data.errors;
            }
        } catch (e) { //network error
            this._data = {};
            this._errObj = {};
            this._errObj[WORTHY_API_ERRORS.ERR_NETWORK] = '';
        }
        this._generateErrorCodesList();
    }

    get data() {
        return this._data;
    }

    _generateErrorCodesList() {
        this._errorCodesList = [];
        for (let k in this._errObj) {
            let code = parseInt(k);
            if (!isNaN(code)) {
                this._errorCodesList.push(code);
            }
        }
    }
    get errors() {
        return this._errorCodesList;
    }

    hasError(errCode) {
        return this.errors.find((c)=>c==errCode);
    }

    get isNetworkError() {
        return this.hasError(WORTHY_API_ERRORS.ERR_NETWORK);
    }

    get isGenericError() {
        return this.hasError(WORTHY_API_ERRORS.ERR_GENERIC);
    }

    get isHttpError() {
        return this.errors.find((c)=>c>=400&&c<=599);
    }

    toString() {
        let errorStrings = [];
        for (let i = 0; i < this.errors.length; i++) {
            errorStrings.push(WorthyApiErrors.errorCodeToText(this.errors[i]));
        }
        return errorStrings.join('\n');
    }

    static errorCodeToText(errorCode) {
        let errorText = null;
        if (errorCode >= 100 && errorCode <= 599) {
            errorText = I18n.getString(`errors::HTTP_${errorCode}`);
            if (errorText === `errors::HTTP_${errorCode}`) { //some unknown error
                if (errorCode >= 400 && errorCode <= 499) {
                    errorText = I18n.getString('errors::HTTP_4XX');
                } else if (errorCode >= 500 && errorCode <= 599) {
                    errorText = I18n.getString('errors::HTTP_5XX');
                } else {
                    errorText = I18n.getString('errors::HTTP_GENERIC');
                }
            }
        } else {
            let errorKey =  Object.keys(WORTHY_API_ERRORS).filter(function(key) {return WORTHY_API_ERRORS[key] === errorCode})[0];
            errorText = I18n.getString(`errors::${errorKey}`);
            if (errorText === `errors::${errorKey}`) {
                errorText = I18n.getString('errors::ERR_GENERIC');
            }
        }
        return errorText;
    }
}
